module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"test":"value","Privacy":"Informativa sulla privacy","TermsAndConditions":"Termini e condizioni"},"en":{"test":"test en","Privacy":"Privacy Information","TermsAndConditions":"General Terms and Conditions "}}')
  delete Component.options._Ctor
}
